import type { ModuleMigrationDef } from "@kubdee/sdk";

// #399 — Full-page forms for tax / insurance / registration. Adds extended
// fields captured from the new forms (vendor, payment method, receipt number,
// notes are already present). Payment method + receipt number + vendor are
// optional text columns; no backfill needed.
export const migration: ModuleMigrationDef = {
  key: "004_add_record_extended_fields",
  version: "1.3.0",
  sql: `
ALTER TABLE \`fleet_registration_records\` ADD COLUMN \`vendor_name\` text;
ALTER TABLE \`fleet_registration_records\` ADD COLUMN \`payment_method\` text;
ALTER TABLE \`fleet_registration_records\` ADD COLUMN \`receipt_no\` text;
ALTER TABLE \`fleet_insurance_records\` ADD COLUMN \`payment_method\` text;
ALTER TABLE \`fleet_tax_records\` ADD COLUMN \`vendor_name\` text;
ALTER TABLE \`fleet_tax_records\` ADD COLUMN \`payment_method\` text;
ALTER TABLE \`fleet_tax_records\` ADD COLUMN \`receipt_no\` text;
`,
};
